export default "__VITE_ASSET__cd0ecb43__"